<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>服务商列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">新增</el-button>
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="状态">
            <el-select v-model="searchForm.status">
              <el-option label="全部" value="" />
              <el-option label="待审核" value="1" />
              <el-option label="通过审核" value="2" />
              <el-option label="审核不通过" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="公司 | 联系人 | 手机号码"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="company" label="公司名"/>
          <el-table-column label="基础资料">
            <template #default="scope">
              <div>联系人：{{ scope.row.name }}</div>
              <div>手机号码：{{ scope.row.mobile }}</div>
              <div>邮箱：{{ scope.row.email }}</div>
              <div>地址：{{ scope.row.address }}</div>
            </template>
          </el-table-column>
          <el-table-column label="服务地区" width="200">
            <template #default="scope">
              <p>{{ scope.row.province }} - {{ scope.row.city }} - {{ scope.row.area }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="loginTime" label="登录时间" width="160"/>
          <el-table-column prop="ip" label="登录IP" width="140"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
                <p v-if="scope.row.status == 1">待审核</p>
                <p v-else-if="scope.row.status == 2">审核通过</p>
                <p v-else-if="scope.row.status == 3">审核不通过</p>
                <p v-else>冻结</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="220" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <el-button size="small" @click="del(scope.row.id)" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const searchForm = reactive({
    status:"",
    words:"",
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.words = ""
    searchForm.status = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.supplierApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (data:any) => {
    router.push("/supplier/add");
  }
  const edit = (id:any) => {
    router.push("/supplier/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.supplierApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  </script>